import React, { createContext, ReactNode, useContext } from "react";

import { Lead } from ".";

interface IProps {
	children?: ReactNode;
}

interface ILeadContextType {
	leads?: Lead[] | null;
	fetchLeadsForAccount?: (accountId: number) => any;
}

const LeadContext = createContext<ILeadContextType>({});

const LeadProvider = (props: IProps) => {
	const fetchLeadsForAccount = async (accountId: number) => {
		const leadData = await fetch(`/api/v1/accounts/${accountId}/leads`);
		const leads = await leadData.json();

		return Lead.fromJsonArray(leads);
	};

	// pass the value in provider and return
	return (
		<LeadContext.Provider
			value={{
				fetchLeadsForAccount,
			}}
		>
			{props.children}
		</LeadContext.Provider>
	);
};

export const useLeads = () => {
	return useContext(LeadContext);
};

const LeadConsumer = LeadContext.Consumer;
export { LeadProvider, LeadConsumer, LeadContext };
